import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../Contexts/GlobalContext';
import useGuiTranslations from '../Components/MultiLanguage/useGuiTranslations';

export default function CustomerSite(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [customerSiteUrl, setCustomerSiteUrl] = useState('');
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {
            //console.log(globalContext.globalState.customerSettings);
            if (globalContext.globalState.customerSettings.domainAlias) {
                let location = 'https://app.happytable.app/';

                if (window.location.href.indexOf("https://testadmin") == 0) {
                    location = 'https://testapp.happytable.app/';
                }
                if (window.location.href.indexOf("http://localhost") == 0) {
                    location = 'http://localhost:3000/';
                }
                console.log(globalContext.globalState.customerSettings.domainAlias);
                setCustomerSiteUrl(location + globalContext.globalState.customerSettings.domainAlias);
            }
        }, [globalContext.globalState.customerSettings.domainAlias]
    )

    const openCustomerSite = () => {
        window.open(customerSiteUrl);
    }


    return (
        <div className={classes.root}>
            <i className="material-icons" style={{ fontSize: '20px' }}>
                open_in_new
            </i>
            <a href="#" onClick={openCustomerSite} aria-label="link-to-customer-site" test-link={customerSiteUrl}>
                {translateGui(19)}
            </a>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        position: 'fixed',
        bottom: 0,
        padding: '10px',
        display: 'flex',
        alignItems: 'center',

        '& a': {
            textDecoration: 'none',
            color: '#424141',
        }
    }
});
